module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$trad.formErrorMessages.fieldMissingMessage))]), _vm._v(" "), _vm._l((_vm.errorPerTabs), function(tab) {
    return _c('section', {
      key: tab.name
    }, [_c('h2', [_vm._v(_vm._s(tab.name))]), _vm._v(" "), _vm._l((tab.errors), function(error, index) {
      return _c('p', {
        key: ("" + (tab.name) + index)
      }, [_vm._v("- " + _vm._s(error.value))])
    })], 2)
  }), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Ok")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb7c35b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/components/OverlayErrorMessage.vue
// module id = 3365
// module chunks = 0